import Card from "./Card.jsx";

export const INFO_CARD_LEVEL = {
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
}

export default ({children, className = '', level = INFO_CARD_LEVEL.INFO}) => {
    return (
        <Card
            className={className}
            isError={level === INFO_CARD_LEVEL.DANGER}
            isWarning={level === INFO_CARD_LEVEL.WARNING}
        >
            {children}
        </Card>
    )
}